import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import {memo} from 'react';
import {FieldError} from '@/components/Common/FormContext';

// The shared input primitive owns its own scrollbar behaviour: hide the scrollbar chrome on
// multiline fields (textareas) while keeping them scrollable. This covers every current and
// future multiline field app-wide instead of relying on a bare `textarea` selector in globals.
// Same technique already used inline in contactform/index.tsx.
const multilineScrollbarSx = {
    '& .MuiInputBase-inputMultiline, & .MuiInputBase-multiline textarea': {
        scrollbarWidth: 'none', // Firefox
        msOverflowStyle: 'none', // IE/legacy Edge
        '&::-webkit-scrollbar': {
            display: 'none', // Chrome/Safari
            width: 0,
            height: 0
        }
    }
};

const TextInput = (props: any): any => {
    const {name, className, label, labelClass, sx, ...rest} = props;

    return (
        <Box className={className}>
            <InputLabel className={labelClass}>{label}</InputLabel>
            <TextField name={name} sx={Array.isArray(sx) ? [multilineScrollbarSx, ...sx] : [multilineScrollbarSx, sx]} {...rest} />
            <FieldError name={name} />
        </Box>
    );
};

export default memo(TextInput);
